(function () {
    'use strict';

    angular.module("page")
        .controller('PageCreateController', PageCreateController);

    PageCreateController.$inject = ['$state', 'pageDataSrvc', 'pageMessagesConst', 'notificationSrvc', 'errorNotificationSrvc'];

    function PageCreateController($state, pageDataSrvc, pageMessagesConst, notificationSrvc, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            url_pl: [],
            url_de: [],
            url_en: [],
            url_cpde: [],
            url_cpen: [],
            title_seo_pl: [],
            title_seo_de: [],
            title_seo_en: [],
            title_seo_cpde: [],
            title_seo_cpen: [],
            description_seo_pl: [],
            description_seo_de: [],
            description_seo_en: [],
            description_seo_cpde: [],
            description_seo_cpen: [],
            keywords_seo_pl: [],
            keywords_seo_de: [],
            keywords_seo_en: [],
            keywords_seo_cpde: [],
            keywords_seo_cpen: [],
            type: [],
            menu: [],
            in_sitemap: [],
            publication_date: [],
            layout: [],
            first_col_content_pl: [],
            second_col_content_pl: [],
            third_col_content_pl: [],
            first_col_content_de: [],
            second_col_content_de: [],
            third_col_content_de: [],
            first_col_content_en: [],
            second_col_content_en: [],
            third_col_content_en: [],
            first_col_content_cpde: [],
            second_col_content_cpde: [],
            third_col_content_cpde: [],
            first_col_content_cpen: [],
            second_col_content_cpen: [],
            third_col_content_cpen: []
        };
        self.pageData = {
            url_pl: '',
            url_de: '',
            url_en: '',
            url_cpde: '',
            url_cpen: '',
            title_seo_pl: '',
            title_seo_de: '',
            title_seo_en: '',
            title_seo_cpde: '',
            title_seo_cpen: '',
            description_seo_pl: null,
            description_seo_de: null,
            description_seo_en: null,
            description_seo_cpde: null,
            description_seo_cpen: null,
            keywords_seo_pl: null,
            keywords_seo_de: null,
            keywords_seo_en: null,
            keywords_seo_cpde: null,
            keywords_seo_cpen: null,
            type: '',
            menu: '',
            in_sitemap: false,
            publication_date: '',
            parent: null,
            layout: '',
            first_col_content_pl: null,
            second_col_content_pl: null,
            third_col_content_pl: null,
            first_col_content_de: null,
            second_col_content_de: null,
            third_col_content_de: null,
            first_col_content_en: null,
            second_col_content_en: null,
            third_col_content_en: null,
            first_col_content_cpde: null,
            second_col_content_cpde: null,
            third_col_content_cpde: null,
            first_col_content_cpen: null,
            second_col_content_cpen: null,
            third_col_content_cpen: null
        };
        self.menuOptions = [];
        self.typeOptions = [];
        self.layoutOptions = [];
        self.layoutOptionsClasses = null;

        self.createPage = createPage;
        self.cleanErrors = cleanErrors;
        self.onLayoutChange = onLayoutChange;

        activate();

        function activate() {
            getMenuOptions();
            getTypeOptions();
            getLayoutOptions();
            getLayoutOptionsClasses();
            setParent();
        }

        function createPage() {
            pageDataSrvc.create(
                self.pageData
            ).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", pageMessagesConst.add);
                    redirect();
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function getMenuOptions() {
            pageDataSrvc.menuOptions().$promise.then(
                function (response) {
                    self.menuOptions = response;
                    self.pageData.menu = self.menuOptions[0][0];
                }
            );
        }

        function getTypeOptions() {
            pageDataSrvc.typeOptions().$promise.then(
                function (response) {
                    self.typeOptions = response;
                    self.pageData.type = self.typeOptions[0][0];
                }
            );
        }

        function getLayoutOptions() {
            pageDataSrvc.layoutOptions().$promise.then(
                function (response) {
                    self.layoutOptions = response;
                    self.pageData.layout = self.layoutOptions[0][0];
                }
            );
        }

        function getLayoutOptionsClasses() {
            pageDataSrvc.layoutOptionsClasses().$promise.then(
                function (response) {
                    self.layoutOptionsClasses = response;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }

        function setParent() {
            if ($state.params.parent) {
                self.pageData.parent = $state.params.parent;
            }
        }

        function redirect() {
            if ($state.params.parent) {
                $state.go('layout.page.update', { pk: $state.params.parent });
            } else {
                $state.go('layout.page.list');
            }
        }

        function onLayoutChange() {
            cleanErrors('layout');
        }
    }
})();
